import React from 'react';
import { DConfirmationModal } from '../../../../../dum';
import { useDeleteOrderSaleMutation } from '../../../../../../services';

interface IDeleteOrderSaleProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    orderSaleId: number | null;
}

export function SDeleteOrderSaleDialog({
    open,
    setOpen,
    orderSaleId,
}: IDeleteOrderSaleProps) {
    const [deleteMutation] = useDeleteOrderSaleMutation();

    return (
        <DConfirmationModal
            open={open}
            setOpen={setOpen}
            callback={async () => {
                if (orderSaleId) {
                    try {
                        await deleteMutation({
                            variables: {
                                OrderSaleId: orderSaleId,
                            },
                        });
                        setOpen(false);
                    } catch (e) {
                        console.error(e);
                    }
                }
            }}
        />
    );
}
